/**
 * 订单管理路由模块
 */

import Layout from '@/layout/Layout.vue'

export default {
  path: '/orders', // 模块路由
  name: '订单管理',
  component: Layout,
  redirect: '/orders/all-orders', // 模块路由重定向
  children: [
    {
      name: '所有订单',
      path: 'all-orders', // 只需加子路由，不要配全路由路径
      component: () => import('@/views/orders/all-orders/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'orders_all-orders'
      }
    },
    {
      name: '订单详情',
      path: 'all-orders/order-details', // 不要使用(all-orders/order-details:id)路由参数的方式，有参数统一用传参，即query的形式
      component: () => import('@/views/orders/all-orders/components/OrderDetails.vue'),
      props: true,
      meta: {
        father: {
          name: '所有订单',
          path: '/orders/all-orders'
        }
      }
    },

    {
      name: '订单退款',
      path: 'all-orders/order-refund',
      component: () => import('@/views/orders/all-orders/components/OrderRefund.vue'),
      meta: {
        father: {
          name: '所有订单',
          path: '/orders/all-orders'
        }
      }
    },
    {
      name: '退款成功',
      path: 'all-orders/order-success',
      component: () => import('@/views/orders/all-orders/components/RefundSuccess.vue'),
      meta: {
        father: {
          name: '所有订单',
          path: '/orders/all-orders'
        }
      }
    },

    {
      name: '异常订单',
      path: 'anomalous',
      component: () => import('@/views/orders/anomalous/index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'orders_anomalous'
      }
    },
    {
      name: '异常订单详情',
      path: 'anomalous/anomalous-details',
      component: () => import('@/views/orders/anomalous/components/AnomalousDetails.vue'),
      props: true,
      meta: {
        father: {
          name: '异常订单',
          path: '/orders/anomalous'
        }
      }
    },

    {
      name: 'SKU替换',
      path: 'sku-replace',
      component: () => import('@/views/orders/replace/index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'orders_sku-replace'
      }
    }
  ]
}
